/* tslint:disable */
import { MonetaryCurrency } from './monetary-currency';
import { ListUnit } from './list-unit';

/**
 */
export class ViewUnits {
    kernelMonetary?: MonetaryCurrency;
    monetary?: MonetaryCurrency;
    listUnit?: ListUnit;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-units.ts